import {SOURCE_COLORS} from './sources';

// ── Styles du DataGrid : colorise les en-têtes par source ────────────────────

export const dataGridSx = {
    borderRadius: 2,
    fontSize: '0.71rem',
    '& .MuiDataGrid-columnHeader': {fontFamily: 'monospace', fontSize: '0.70rem'},
    '& .MuiDataGrid-columnHeaderTitle': {fontWeight: 'bold'},
    '& .col-header--address':  {backgroundColor: '#37474f', color: '#fff'},
    '& .col-header--synthese': {backgroundColor: '#00695c', color: '#fff'},
    '& .col-group--synthese > .MuiDataGrid-columnGroupHeader':
        {backgroundColor: '#00695c22', borderBottom: '2px solid #00695c'},
    '& .col-group--synthese .MuiDataGrid-columnGroupHeaderTitle':
        {color: '#00695c', fontWeight: 'bold', fontSize: '0.72rem'},
    ...Object.fromEntries(
        Object.entries(SOURCE_COLORS).flatMap(([src, color]) => [
            [`& .col-header--${src}`, {backgroundColor: color, color: '#fff'}],
            [`& .col-group--${src} > .MuiDataGrid-columnGroupHeader`,
                {backgroundColor: `${color}22`, borderBottom: `2px solid ${color}`}],
            [`& .col-group--${src} .MuiDataGrid-columnGroupHeaderTitle`,
                {color, fontWeight: 'bold', fontSize: '0.72rem'}],
        ])
    ),
};

